export default __webpack_public_path__ + "static/media/background.cc1a83a8.jpg";